import store from "../store/index";
import axios from "axios";


export async function axiosUploadTypeArrayBuffer(choice, zipName) {
  await axios({ method: "post", url: "allExcelZipDownload",  data : {choice : choice} , responseType: "arraybuffer"}).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", zipName + ".zip"); //or any other extension
    document.body.appendChild(link);
    link.click();
    store.commit('LOADER',false);
    let loader = {
        loaderToUpdate: false,
    }
    store.commit("LOADERTOUPDATE", loader);
  }).catch(() => console.log("error occured"));
}
